// extracted by mini-css-extract-plugin
export default {"horizontalScroll":"style_horizontalScroll__bX4P7","dragging":"style_dragging__0sSbg","scroll":"style_scroll__zg2NA"};